

const initialState = {notification: false,numUnread:0};

function notificationReducer(state : any = initialState,action : any){
    let nextState;

    switch (action.type){
        case 'SET_NOTIFICATION':
            nextState = _setNotification(state,action);
            return nextState || state;
        default :
            return state;
    }
}

function _setNotification(state :any,action:any){
    console.log('setNotification',action.value);
    const notification=action.value.notification;
    const numUnread = action.value.numUnread;

    return {
        ...state,
        notification : notification,
        numUnread: numUnread
    }
}

export default notificationReducer;
